import CustomerProfileContainer from './CustomerProfileContainer'

export default function CustomerProfileScreen() {
    return <CustomerProfileContainer />
}
